<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">
      {{ $t("document sign") }}
    </div>
    <div class="grid is-col-min-7">
      <div class="cell" @click="manage_documents">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn2.iconfinder.com/data/icons/startup-butterscotch-vol-1/512/Contract-512.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("documents") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="manage_addressees">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn1.iconfinder.com/data/icons/soleicons-fill-vol-1/64/addressee_receiver_recepient_consignee_sender_mail-512.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("addressees") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="manage_signing_profiles">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn1.iconfinder.com/data/icons/shopping-416/64/LOCATION-area-site-mark-point-512.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("signing template") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="manage_profiles">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.freepik.com/256/1813/1813989.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("profiles") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { warning_message, get } from "@/utils";

export default {
  name: "DocumentSignatureIndex",
  components: {},
  data() {
    return {
      is_loading: false,
      current_enterprise: undefined,
      current_period: undefined,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    manage_documents() {
      let v = this;
      v.$router.push({
        path: "/document-sign/document",
      });
    },
    manage_addressees() {
      let v = this;
      v.$router.push({
        path: "/document-sign/addressee",
      });
    },
    manage_signing_profiles() {
      let v = this;
      v.$router.push({
        path: "/document-sign/signing-profile",
      });
    },
    manage_profiles() {
      let v = this;
      v.$router.push({
        path: "/document-sign/profiles",
      });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
